import { Mail, MessageCircle, Phone } from "lucide-react";
import { BRAND } from "@/content/site";
import { waHref } from "@/content/media";
import { useLang } from "@/lang";

export default function Footer() {
  const { t, isEs } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer-section" className="bg-navy-3 pb-10 pt-16 lg:pb-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-crest.png" alt="Equipment Concierge EC crest logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/50" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-cream">Equipment Concierge</span>
            </div>
            <p className="mt-5 font-serif text-xl italic text-cream/70">{t.footer.tagline}</p>
            <p className="mt-3 font-serif text-lg italic text-gold">{t.nico}</p>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">{t.footer.contact}</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={BRAND.phoneHref} data-testid="footer-phone-link" className="inline-flex items-center gap-2.5 text-cream/80 transition-colors duration-300 hover:text-gold">
                  <Phone className="h-4 w-4 text-gold" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={waHref(isEs ? "es" : "en")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex items-center gap-2.5 text-cream/80 transition-colors duration-300 hover:text-gold">
                  <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp
                </a>
              </li>
              <li>
                <a href={BRAND.emailHref} data-testid="footer-email-link" className="inline-flex items-center gap-2.5 break-all text-cream/80 transition-colors duration-300 hover:text-gold">
                  <Mail className="h-4 w-4 shrink-0 text-gold" /> {BRAND.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">{t.footer.area}</p>
            <p className="mt-5 text-sm leading-relaxed text-cream/60">{t.footer.areaLine}</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-cream/10 pt-6 text-[11px] uppercase tracking-[0.2em] text-cream/40 sm:flex-row sm:items-center">
          <span data-testid="footer-copyright">© {year} Equipment Concierge. {t.footer.rights}</span>
          <span>Wellington, Florida</span>
        </div>
      </div>
    </footer>
  );
}
